import { AnaColumn } from "../forms-template.service";

export const crmAggiornamentiGrid: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    class: '',
    colCount: '1',
    data: [
      {
        type: 'campo',
        dataField: 'dataora',
        colVisible: true,
        dataType: 'datetime',
        editorType: "dxDateBox",
        format: "dd/MM/yyyy hh:mm",
        caption: 'Data e Ora',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'codAss',
        colVisible: true,
        dataType: 'string',
        caption: 'CodAss.',
        colAlignment: 'center',
      },
      /*{
        type: 'campo',
        dataField: 'contatto',
        colVisible: true,
        dataType: 'string',
        caption: 'Contatto',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'agente',
        colVisible: true,
        dataType: 'string',
        caption: 'Agente',
        colAlignment: 'left',
      },*/
      {
        type: 'campo',
        dataField: 'nomefile',
        colVisible: true,
        dataType: 'string',
        caption: 'Nome File',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'dimensione',
        colVisible: true,
        caption: 'Dimensione',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'errore',
        colVisible: true,
        dataType: 'string',
        caption: 'Messaggio',
        colAlignment: 'left',
        colWidth: 500
      },
      {
        type: 'campo',
        dataField: 'TipoChiaveHardware',
        colVisible: true,
        dataType: 'string',
        caption: 'Tipo Chiave',
        colAlignment: 'left',
      },
    ]
  },
]

export const crmAggiornamentiFiltri: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    captionClass: 'd-none',
    class: '',
    colCount: "5",
    groupValidation: [
      {
        sourceDataField: 'daData',
        targetDataField: 'aData',
        operator: '<=',
        message: 'Fornire delle date valide',
        keyError: 'daDataADataRange'
      },

    ],
    data: [
      {
        type: 'campo',
        dataField: 'daData',
        caption: 'Da Data',
        editorType: 'dxDateBox',
        format: "dd/MM/yyyy",
        visible: true,
        dataType: 'date',
        showClearButton: true,
        nCol: 2,
        class: 'crm_contatti_editor',
        odataFilter: '>=',
        odataType: 'string',
      },

      {
        type: 'campo',
        dataField: 'aData',
        caption: 'A Data',
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: 'dxDateBox',
        visible: true,
        showClearButton: true,
        nCol: 2,
        class: 'crm_contatti_editor',
        odataFilter: '<=',
        odataType: 'string'
      },
      {
        type: 'campo',
        dataField: 'codAss',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Ass.',
        showClearButton: false,
        uppercase: true,
        nCol: 2,
        odataFilter: 'contains',
        odataType: 'string',
        class: 'crm_contatti_editor',
      },
      {
        type: 'campo',
        dataField: 'contatto',
        colVisible: true,
        dataType: 'string',
        caption: 'Contatto',
        nCol: 4,
        disableOnUpdate: true,
        odataFilter: 'contains',
        odataType: 'string',
        class: 'crm_contatti_editor',
        dynamic: {
          valueExpr: 'Cod',
          queryString: '',
          displayExpr: 'RagSoc',
          dataSource: 'contatti',
          service: '',
          autocomplete: false,
          caption: 'Lista Contatti',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Contatti',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'RagSoc',
                dataType: '',
                caption: 'Ragione Sociale',
                allowEditing: true,
                colVisible: true
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'agente',
        colVisible: true,
        dataType: 'string',
        caption: 'Agente',
        nCol: 4,
        odataFilter: 'contains',
        odataType: 'string',
        disableOnUpdate: true,
        class: 'crm_contatti_editor',
        dynamic: {
          valueExpr: 'Cod',
          queryString: '',
          displayExpr: 'RagSoc1',
          dataSource: 'agenti',
          service: '',
          autocomplete: false,
          caption: 'Lista Agenti',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Agenti',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'RagSoc1',
                dataType: '',
                caption: 'Ragione Sociale',
                allowEditing: true,
                colVisible: true
              },
              {
                dataField: 'Resp',
                dataType: '',
                caption: 'Responsabile',
                allowEditing: true,
                colVisible: true
              },
            ],
          },
        },
      },
    ]
  },
]